function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1912(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 43.35,
    height: 32.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 16.275,
    fontFamily: "Arial"
  }, "\n        Vinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.55,
    width: 43.35,
    height: 34.63,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.771666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 49.864999999999995,
    fontFamily: "Arial"
  }, "\n        Geauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 67.19,
    width: 43.35,
    height: 37.46,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 85.92,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 104.64,
    width: 43.35,
    height: 39.57,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 124.425,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 144.22,
    width: 43.35,
    height: 40.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7942857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 164.5,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 184.78,
    width: 43.35,
    height: 44.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2250000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 206.88,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 228.98,
    width: 43.35,
    height: 48.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2250000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 253.42,
    fontFamily: "Arial"
  }, "\n        Morrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.86,
    width: 43.35,
    height: 49.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 302.40500000000003,
    fontFamily: "Arial"
  }, "\n        Noble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 326.94,
    width: 43.35,
    height: 50.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.41875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 351.985,
    fontFamily: "Arial"
  }, "\n        Harrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 377.03,
    width: 43.35,
    height: 50.25,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2250000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 402.155,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 427.28,
    width: 43.35,
    height: 52.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2250000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 453.65999999999997,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480.04,
    width: 43.35,
    height: 53.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 506.735,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 533.43,
    width: 43.35,
    height: 54.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.192857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 560.7399999999999,
    fontFamily: "Arial"
  }, "\n        Hocking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 588.05,
    width: 43.35,
    height: 54.95,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.8375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 615.525,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 643,
    width: 43.35,
    height: 57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.192857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 21.675,
    y: 671.5,
    fontFamily: "Arial"
  }, "\n        Wyandot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 0,
    width: 47.65,
    height: 51.9,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 67.175,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 0,
    width: 47.66,
    height: 51.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.808571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.83,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.66,
    y: 0,
    width: 47.93,
    height: 51.9,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.988333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.625,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.59,
    y: 0,
    width: 47.96,
    height: 51.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.57,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.56,
    y: 0,
    width: 48.88,
    height: 51.9,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.146666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Gallia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.44,
    y: 0,
    width: 50.1,
    height: 51.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.49,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Defiance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.54,
    y: 0,
    width: 50.1,
    height: 51.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1571428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.59000000000003,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.65,
    y: 0,
    width: 51.65,
    height: 51.9,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 409.47499999999997,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Medina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.3,
    y: 0,
    width: 51.73,
    height: 51.9,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.621666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.165,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.03,
    y: 0,
    width: 52.86,
    height: 51.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.379999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.4599999999999,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.89,
    y: 0,
    width: 53.13,
    height: 51.9,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.379999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.455,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.02,
    y: 0,
    width: 53.25,
    height: 51.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.379999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.645,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Meigs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.27,
    y: 0,
    width: 53.73,
    height: 51.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.135,
    y: 25.95,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 51.9,
    width: 56.62,
    height: 49.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1414285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 76.895,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 101.89,
    width: 56.62,
    height: 51.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 127.58500000000001,
    fontFamily: "Arial"
  }, "\n        Preble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 153.28,
    width: 56.62,
    height: 51.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.375714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 179.095,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 204.91,
    width: 56.62,
    height: 52.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.716666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 231.06,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 257.21,
    width: 56.62,
    height: 52.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.502857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 283.46999999999997,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 309.73,
    width: 56.62,
    height: 52.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 336.09000000000003,
    fontFamily: "Arial"
  }, "\n        Pickaway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 362.44,
    width: 56.62,
    height: 53.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.915000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 389.185,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 415.94,
    width: 56.62,
    height: 53.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 442.71,
    fontFamily: "Arial"
  }, "\n        Williams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 469.48,
    width: 56.62,
    height: 55.71,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.96375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 497.33500000000004,
    fontFamily: "Arial"
  }, "\n        Auglaize\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 525.19,
    width: 56.62,
    height: 56.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.29111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 553.6400000000001,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 582.08,
    width: 56.62,
    height: 58.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.436666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 611.465,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.35,
    y: 640.86,
    width: 56.62,
    height: 59.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.66,
    y: 670.4300000000001,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 51.9,
    width: 56.54,
    height: 59.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.24,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Van_Wert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.51,
    y: 51.9,
    width: 57.72,
    height: 59.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.413333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.37,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Coshocton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.23,
    y: 51.9,
    width: 58.11,
    height: 59.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.285,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.34,
    y: 51.9,
    width: 58.21,
    height: 59.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.27625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.445,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.55,
    y: 51.9,
    width: 58.78,
    height: 59.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.397142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.94,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.33,
    y: 51.9,
    width: 59.35,
    height: 59.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.41875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.005,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.67,
    y: 51.9,
    width: 60.45,
    height: 59.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.89500000000004,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Clermont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.12,
    y: 51.9,
    width: 62.81,
    height: 59.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.845
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 540.525,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.93,
    y: 51.9,
    width: 64,
    height: 59.38,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.93,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.93,
    y: 51.9,
    width: 64.07,
    height: 59.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.876000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.9649999999999,
    y: 81.59,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 111.28,
    width: 63.65,
    height: 61.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.296
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.795,
    y: 142.02,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 172.76,
    width: 63.65,
    height: 62.01,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.334999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.795,
    y: 203.765,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 234.77,
    width: 63.65,
    height: 63.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.93625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.795,
    y: 266.515,
    fontFamily: "Arial"
  }, "\n        Sandusky\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 298.26,
    width: 63.65,
    height: 65.91,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.072222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.795,
    y: 331.215,
    fontFamily: "Arial"
  }, "\n        Fairfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 364.17,
    width: 63.65,
    height: 66.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.795,
    y: 397.27000000000004,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 430.37,
    width: 63.65,
    height: 66.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.795,
    y: 463.505,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 496.64,
    width: 63.65,
    height: 67.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.092857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.795,
    y: 530.1949999999999,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 563.75,
    width: 63.65,
    height: 67.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.95625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.795,
    y: 597.495,
    fontFamily: "Arial"
  }, "\n        Guernsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.97,
    y: 631.24,
    width: 63.65,
    height: 68.76,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.795,
    y: 665.62,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.62,
    y: 111.28,
    width: 62.85,
    height: 71.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.04500000000002,
    y: 146.925,
    fontFamily: "Arial"
  }, "\n        Athens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.47,
    y: 111.28,
    width: 64.9,
    height: 71.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.92,
    y: 146.925,
    fontFamily: "Arial"
  }, "\n        Ross\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.36,
    y: 111.28,
    width: 65.88,
    height: 71.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.587999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.3,
    y: 146.925,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.25,
    y: 111.28,
    width: 66.43,
    height: 71.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.6075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.46500000000003,
    y: 146.925,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.68,
    y: 111.28,
    width: 67.66,
    height: 71.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.532
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.51,
    y: 146.925,
    fontFamily: "Arial"
  }, "\n        Darke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.34,
    y: 111.28,
    width: 67.86,
    height: 71.29,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.27,
    y: 146.925,
    fontFamily: "Arial"
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.2,
    y: 111.28,
    width: 69.9,
    height: 71.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.1500000000001,
    y: 146.925,
    fontFamily: "Arial"
  }, "\n        Scioto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.1,
    y: 111.28,
    width: 70.9,
    height: 71.29,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.8625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.5500000000001,
    y: 146.925,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.62,
    y: 182.57,
    width: 76.55,
    height: 68.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.732
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.895,
    y: 216.89999999999998,
    fontFamily: "Arial"
  }, "\n        Miami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.62,
    y: 251.23,
    width: 76.55,
    height: 70.21,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.77625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.895,
    y: 286.335,
    fontFamily: "Arial"
  }, "\n        Trumbull\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.62,
    y: 321.44,
    width: 76.55,
    height: 70.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.827777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.895,
    y: 356.665,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.62,
    y: 391.89,
    width: 76.55,
    height: 72.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.584
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.895,
    y: 428.34999999999997,
    fontFamily: "Arial"
  }, "\n        Allen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.62,
    y: 464.82,
    width: 76.55,
    height: 75.96,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.895,
    y: 502.8,
    fontFamily: "Arial"
  }, "\n        Ashtabula\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.62,
    y: 540.78,
    width: 76.55,
    height: 77.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.654999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.895,
    y: 579.345,
    fontFamily: "Arial"
  }, "\n        Tuscarawas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.62,
    y: 617.91,
    width: 76.55,
    height: 82.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.895,
    y: 658.9549999999999,
    fontFamily: "Arial"
  }, "\n        Licking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.17,
    y: 182.57,
    width: 82.59,
    height: 77.92,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.986666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.465,
    y: 221.53,
    fontFamily: "Arial"
  }, "\n        Lorain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.76,
    y: 182.57,
    width: 84.72,
    height: 77.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.657777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.12,
    y: 221.53,
    fontFamily: "Arial"
  }, "\n        Muskingum\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.48,
    y: 182.57,
    width: 93.93,
    height: 77.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.131428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.44500000000005,
    y: 221.53,
    fontFamily: "Arial"
  }, "\n        Belmont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.4,
    y: 182.57,
    width: 97.56,
    height: 77.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.792
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.18,
    y: 221.53,
    fontFamily: "Arial"
  }, "\n        Columbiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.97,
    y: 182.57,
    width: 101.03,
    height: 77.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.986666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.485,
    y: 221.53,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.17,
    y: 260.49,
    width: 93.86,
    height: 84.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.804
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.09999999999997,
    y: 302.5,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.17,
    y: 344.52,
    width: 93.86,
    height: 104.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.7325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.09999999999997,
    y: 396.625,
    fontFamily: "Arial"
  }, "\n        Mahoning\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.17,
    y: 448.73,
    width: 93.86,
    height: 116.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.643333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.09999999999997,
    y: 507.1,
    fontFamily: "Arial"
  }, "\n        Summit\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.17,
    y: 565.46,
    width: 93.86,
    height: 134.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.772
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.09999999999997,
    y: 632.73,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.03,
    y: 260.49,
    width: 107.65,
    height: 165.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.85499999999996,
    y: 343.025,
    fontFamily: "Arial"
  }, "\n        Lucas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.68,
    y: 260.49,
    width: 113.16,
    height: 165.07,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.315999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 498.26,
    y: 343.025,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.85,
    y: 260.49,
    width: 145.15,
    height: 165.07,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.14375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.4250000000001,
    y: 343.025,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.03,
    y: 425.57,
    width: 176.68,
    height: 274.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.37,
    y: 562.785,
    fontFamily: "Arial"
  }, "\n        Cuyahoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.71,
    y: 425.57,
    width: 189.29,
    height: 274.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.66125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.355,
    y: 562.785,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1912);
export default __webpack_public_path__ + "static/media/1912.5562694ad01831a0d467b4c1fb9b9362.svg";
export { ForwardRef as ReactComponent };